const host = process.env.REACT_APP_API_HOST || ''

const getApiEnvironment = () => {
  if (host.includes('-test')) {
    return { host, label: 'TEST', variant: 'secondary' }
  }
  if (host) {
    return { host, label: 'PROD', variant: 'danger' }
  }
  return { host: 'unknown host', label: 'unknown host', variant: 'warning' }
}

export default getApiEnvironment
